import React from 'react';
import styled, { css } from 'styled-components';
import { variables } from './variables';
import { Input, Table, Button, Checkbox } from 'react-inv-forms';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;
/* Details View Shared Styles */
export const SharedMediaButtonMargin = css`
  margin-bottom: 10px;
  margin-left: 0;
  margin-right: 20px;
  font-size: 1.2rem;
  height: 30px;
  padding: 6px 12px;
`;

export const DisabledContent = styled('div')`
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  &::after {
    content: '';
    display: block;
    position: absolute;
    background-color: ${variables.colorBackground};
    opacity: 0.75;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }
  .anticon-loading {
    position: absolute;
    top: 30%;
    left: 40%;
    z-index: 10;
    font-size: 3rem;
  }
`;

export const SharedButtonFontStyle = css`
  height: 40px;
  font-size: 1.6rem;
  font-weight: 300;
  margin: 0 2rem 2rem 0;
`;

export const SharedMediaButtonFontStyle = css`
  font-size: 1.2rem;
  height: unset;
`;

export const DetailsContainerSharedStyle = css`
  border-top: 1px solid ${variables.colorBorder};
  border-bottom: 1px solid ${variables.colorBorder};
  padding: 10px;
  background-color: ${variables.colorBackground};
`;

/* Shared font style for subject card form */
export const SubjectCardFormElementFontStyle = css`
  font-size: 1.8rem;
  font-weight: 400;
  color: ${variables.colorMainText};
`;
interface ContextSearchProps {
  float?: 'right' | 'left';
  [key: string]: unknown;
}
/* Context Search Component */
export const ContextSearch = styled(({ float, ...props }: ContextSearchProps) => (
  <Search enterButton={<SearchOutlined />} allowClear {...props} />
))`
  border-color: ${variables.colorWhite};
  width: max-content;
  font-weight: 400;
  margin: 0;
  padding: 2px 0;
  border-radius: 0;
  ${({ float }) =>
    float &&
    `
      float: ${float};
  `}

  .ant-input-suffix {
    display: none;
  }

  .ant-input-search-button {
    color: inherit;
    background-color: ${variables.colorWhite};
    border-color: ${variables.colorWhite};
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
    height: 100%;
  }
  .ant-input-search-button:focus {
    box-shadow: none;
    outline: none;
  }
  .ant-input-search {
    border-color: ${variables.colorWhite};
    padding: 0;
    line-height: 1.2rem;
  }
  &:hover:not(.ant-input-affix-wrapper-disabled) {
    cursor: pointer;
    border-color: ${variables.colorWhite};
    border-bottom-color: ${variables.colorDecorator};
    .ant-input-search-button:not(:disabled) svg {
      fill: ${variables.colorDecorator};
    }
  }

  &.ant-input-affix-wrapper:focus,
  &.ant-input-affix-wrapper-focused {
    border-color: ${variables.colorWhite};
    outline: none;
    box-shadow: none;
    .anticon svg {
      fill: ${variables.colorDecorator};
    }
  }
  .anticon svg {
    fill: ${variables.colorDecorator};
    width: 2.4rem;
    height: 2.4rem;
  }
  .ant-input-group-addon,
  .ant-input-search,
  .ant-input-search:hover {
    color: ${variables.colorWhite};
    background-color: ${variables.colorWhite};
    .ant-btn {
      margin: 0;
    }
  }
  &.ant-input-affix-wrapper-disabled {
    background-color: ${variables.colorWhite};
    border-color: ${variables.colorWhite};
  }
  .ant-input-search-button:disabled {
    border-color: ${variables.colorWhite};
    background-color: ${variables.colorWhite};
    &:hover svg {
      fill: ${variables.colorDecorator};
    }
  }
  .ant-input {
    text-align: right;
    font-size: 2rem;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 6px !important;
  }

  @media (max-width: 668px), (max-height: 412px) {
    /* width: 200px; */
    align-self: flex-end;
    input {
      font-size: 1.4rem;
    }
    .anticon-close-circle {
      > svg {
        width: 1.2rem;
        height: 1.2rem;
      }
    }
  }
`;
/* Header for Labels */
export const Label = styled.span`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${variables.colorDecorator};
  display: inline;
`;

/* Inline Table */
export const CustomTable = styled(Table)`
  box-shadow: 0px 0px 3px 2px ${variables.colorBackground};
  border-bottom: 1px solid ${variables.colorGrey};
  thead.ant-table-thead {
    background-color: ${variables.colorDecorator};
  }
  thead.ant-table-thead > tr > th {
    background-color: ${variables.colorDecorator};
    color: ${variables.colorWhite};
  }
  thead.ant-table-thead th.ant-SingleColumn-has-sorters:hover {
    background-color: ${variables.colorDecorator};
  }
  tfoot.ant-table-summary > tr > td {
    background-color: ${variables.colorBorder};
  }
  &:not(.table__readOnly) {
    thead.ant-table-thead > tr > th {
      border: 2px solid ${variables.colorDecorator};
    }
  }
  &.table__readOnly {
    margin-bottom: 20px;
    border-bottom: 1px solid ${variables.colorDecorator};
    margin-top: 8px;
    tr.ant-table-row-level-0 td.ant-table-cell,
    tr.ant-table-row-level-0:hover td.ant-table-cell,
    thead.ant-table-thead > tr > th,
    tbody.ant-table-tbody > tr > td,
    tfoot.ant-table-summary > tr > td {
      background-color: ${variables.colorBackground} !important;
      padding: 4px;
      color: rgba(0, 0, 0, 0.8);
      cursor: text;
    }
    thead.ant-table-thead > tr > th {
      border-bottom: 1px solid ${variables.colorBorder};
    }

    span.ant-checkbox-checked span.ant-checkbox-inner,
    span.ant-checkbox-checked span.ant-checkbox-inner::after {
      background-color: ${variables.colorBackground};
    }
    span.ant-checkbox:hover,
    span.ant-checkbox-checked span.ant-checkbox-inner,
    span.ant-checkbox-checked,
    span.ant-checkbox-checked:hover span.ant-checkbox-inner,
    .ant-checkbox-wrapper:hover span.ant-checkbox-checked,
    span.ant-checkbox-checked:hover span.ant-checkbox-checked::after {
      background-color: ${variables.colorBackground};
      border-color: ${variables.colorBackground};
    }
    label.ant-checkbox-wrapper,
    .ant-checkbox-input:hover {
      cursor: default;
    }
    label.ant-checkbox-wrapper,
    span.ant-checkbox.ant-checkbox-checked span.ant-checkbox-inner {
      border-color: ${variables.colorBackground};
    }
  }
  tbody.ant-table-tbody > tr > td:not(:first-child) {
    min-width: unset;
    max-width: unset;

    .anticon {
      font-size: 16px;
    }
  }
  tr.ant-table-row-level-0:hover .ant-table-cell {
    background-color: transparent !important;
  }
  tfoot.ant-table-summary td.cell__info_error {
    color: ${variables.colorDecorator};
    font-weight: 700;
  }
  thead.ant-table-thead > tr > th,
  tbody.ant-table-tbody > tr > td,
  tfoot.ant-table-summary > tr > td {
    padding: 8px;
    font-size: 1.8rem;
  }
  tbody.ant-table-tbody > tr > td {
    font-weight: 400;
  }
  thead::after {
    content: none !important;
  }
  tfoot.ant-table-summary > tr > td {
    font-weight: 700;
    text-transform: uppercase;
  }
  &.hide_columns thead.ant-table-thead {
    display: none;
  }
  tr.ant-table-row-level-0:hover .ant-table-cell {
    cursor: default;
  }
  tfoot.ant-table-summary {
    color: ${variables.colorMainText};
    font-family: ${variables.fontText};
    background-color: ${variables.colorBackground};
  }
  thead.ant-table-thead div.ant-SingleColumn-sorters {
    padding: 0;
  }
  span.ant-SingleColumn-sorter-inner {
    display: none;
  }
  tr.ant-table-row-level-0 td.ant-SingleColumn-sort {
    background: ${variables.colorWhite};
  }
  label.ant-checkbox-wrapper:hover span.ant-checkbox-inner {
    border-color: ${variables.colorBackground} !important;
    cursor: pointer !important;
  }
  tr.ant-table-placeholder {
    font-weight: 400;
    text-transform: none;
    font-style: italic;
  }
  @media (max-width: 1500px) and (min-width: 769px) {
    &.ant-table-wrapper {
      width: 100% !important;
    }
  }
`;

interface SpanTitleProps {
  /** długość tytułu w tablicy */
  width: number;
  /** wartość wyświetlana */
  value: React.ReactNode;
}
/* Span to table columns title */
export const SpanTitle = styled(({ width, value, ...props }: SpanTitleProps) => <span {...props}>{value}</span>)`
  display: inline-block;
  width: ${props => (props.width ? props.width : null)}px;
`;

/* Round Button */
export const FabButton = styled(Button)`
  margin: 8px 0 0 0 !important;
  padding: 0 !important;
  line-height: 0;
  float: right;
  img {
    margin: 0 !important;
  }
  &:disabled img {
    filter: grayscale(100%) !important;
  }
`;

export const InlineButton = styled(Button)`
  margin-top: 5px;
  font-weight: 400;

  .anticon {
    line-height: 1;
    font-size: 18px;
    margin-right: 8px;
    padding: 0 !important;
  }

  @media (max-width: 1500px) and (min-width: 769px) {
    margin: 10px 0 0 5px;
  }
  @media (max-width: 769px) {
    margin: 10px 0 0 5px;
  }
`;
interface InlineLinkButtonProps {
  bold: boolean;
  [key: string]: unknown;
}
/* export const InlineLinkButton = styled(Button)` */
export const InlineLinkButton = styled(({ bold = false, ...props }: InlineLinkButtonProps) => <Button {...props} />)`
  color: ${variables.colorMainText};
  &,
  &:hover,
  &:active,
  &:focus {
    padding: 0;
    text-decoration: ${props => (props.bold ? 'underline' : 'none')};
    text-transform: none;
    font-weight: ${props => (props.bold ? 700 : 400)};
    border: none;
    background-color: ${variables.colorWhite};
    padding: 0;
    display: inline-block;
    margin-top: 0;
    box-shadow: none;
  }
  &.ant-btn:not([disabled]):hover {
    text-decoration: underline;
  }
  &.ant-btn:disabled {
    background-color: ${variables.colorWhite};
  }
  &:hover,
  &:active,
  &:focus {
    color: ${variables.colorInfo};
  }
`;

export const CheckboxReverse = styled(Checkbox)`
  border-color: ${variables.colorWhite};
  &:hover {
    border-color: ${variables.colorWhite};
  }
  span.ant-checkbox {
    margin-right: 0;
  }
  span.ant-checkbox-inner::after {
    border-color: ${variables.colorDecorator};
  }
  span.ant-checkbox-checked span.ant-checkbox-inner,
  span.ant-checkbox-inner::after {
    background: ${variables.colorWhite};
  }
  label.ant-checkbox-wrapper:hover span.ant-checkbox-inner,
  span.ant-checkbox.ant-checkbox-checked span.ant-checkbox-inner,
  span.ant-checkbox-checked,
  span.ant-checkbox-checked::after,
  span.ant-checkbox-checked:hover span.ant-checkbox-checked::after,
  span.ant-checkbox:hover span.ant-checkbox::after,
  &.ant-checkbox-wrapper:hover span.ant-checkbox-checked::after,
  &.ant-checkbox-wrapper-checked span.ant-checkbox-checked::after {
    border-color: ${variables.colorWhite};
  }
  span.ant-checkbox-inner {
    border-color: ${variables.colorBorder};
  }
`;

/* Subject Card form */
export const FormDataTextStyle = css`
  ${SubjectCardFormElementFontStyle};
  margin-bottom: 6px;
  @media (max-width: 769px) {
    /* font-size: 1.4rem; */
  }
`;

interface FormDataTextProps {
  warning: boolean;
  [key: string]: unknown;
}
export const FormDataText = styled(({ warning, ...props }: FormDataTextProps) => <span {...props} />)`
  ${FormDataTextStyle};
  ${({ warning }) =>
    warning &&
    `
    color: ${variables.colorDecorator};
    font-style: italic;
  `};
`;

export const FormBoxContainer = styled.div`
  margin: 20px auto;
  p {
    ${FormDataTextStyle};
  }
`;
